import React, { PropTypes } from 'react';

import './style.scss';

const RepliesListContentMain = (props) => (
  <div className="RepliesListContentMain">
    {props.children}
  </div>
);

RepliesListContentMain.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};

export default RepliesListContentMain;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/RepliesList/RepliesListContentMain/index.js
 **/